// extracted by mini-css-extract-plugin
export default {"page":"Contact_page__iGPPL"};